import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import AnimatedStat from "@/components/base/AnimatedStat";

const brands = [
  { name: "Nivea", logo: "https://storage.readdy-site.link/project_files/9d47c388-655f-4be5-bf40-a8a867a3d101/28a5f732-3ee5-45b8-b3af-4d56d19a93ab_nivea.png?v=2882af9fd5a561d85f01c40c5620a6d1" },
  { name: "Nestlé", logo: "https://storage.readdy-site.link/project_files/9d47c388-655f-4be5-bf40-a8a867a3d101/36afd2e9-80f0-4f8d-9ec8-36338dc190e6_nestle.png?v=3ada4adb61199dd56b71e9926b90ee85" },
  { name: "Mercado Libre", logo: "https://storage.readdy-site.link/project_files/9d47c388-655f-4be5-bf40-a8a867a3d101/da7d26f0-ab8c-424d-8b03-ac9e032efe12_mercado-libre.png?v=33aa2c8ae4e336a7cacd21f8ab1384b2" },
  { name: "Maybelline", logo: "https://storage.readdy-site.link/project_files/9d47c388-655f-4be5-bf40-a8a867a3d101/c13ab558-2b1a-4d26-9cc1-a3680fa88d17_maybelline.png?v=cee3a7c5d6e3800b810d76ed3272297d" },
  { name: "L'Oreal", logo: "https://storage.readdy-site.link/project_files/9d47c388-655f-4be5-bf40-a8a867a3d101/407c56ca-d67b-443b-9954-5fa217107ded_loreal.png?v=e185b649e5c954e2436c9f1bf5a1c9ad" },
  { name: "Liquid IV", logo: "https://storage.readdy-site.link/project_files/9d47c388-655f-4be5-bf40-a8a867a3d101/874686f4-8744-4612-9f1f-204059f0748e_liquid-iv.png?v=5b552aac7930e55f327af4abb17d7b07" },
  { name: "American Eagle", logo: "https://storage.readdy-site.link/project_files/9d47c388-655f-4be5-bf40-a8a867a3d101/a69c5783-e3f8-466a-a69a-f77a047954be_american-eagle.png?v=cb5d3f845f978c870ff3ff4b143f9edc" },
  { name: "Coach", logo: "https://storage.readdy-site.link/project_files/9d47c388-655f-4be5-bf40-a8a867a3d101/bf00191b-0e8f-4102-8d8d-77d7fed3cb96_coach.png?v=d74d4632dbdbaaa65a76fcc02f88800c" },
  { name: "Eucerin", logo: "https://storage.readdy-site.link/project_files/9d47c388-655f-4be5-bf40-a8a867a3d101/6af83d3c-a4fb-4153-a5c2-fbf18422f6a5_eucerin.png?v=4e87b0ab115cd787611f2270ef1e7e80" },
  { name: "Hawkers", logo: "https://storage.readdy-site.link/project_files/9d47c388-655f-4be5-bf40-a8a867a3d101/91a5a902-36b8-4736-a914-4d746ddfa139_hawkers.png?v=bad0056d242dcc734bafc9eba021de70" },
  { name: "OXXO", logo: "https://storage.readdy-site.link/project_files/9d47c388-655f-4be5-bf40-a8a867a3d101/32020f5a-0d45-4b6e-9cd5-71a9c0eec0b8_oxxo.png?v=3157d4936a7231c56a21c1bff6530fca" },
  { name: "Warner Bros", logo: "https://storage.readdy-site.link/project_files/9d47c388-655f-4be5-bf40-a8a867a3d101/dec2d4d2-7c1b-4ebc-9bc3-0ccd80e77b00_warner-bros.png?v=f6fcea3362137d3f528fdaa797d2aee4" },
  { name: "Tom Ford", logo: "https://storage.readdy-site.link/project_files/9d47c388-655f-4be5-bf40-a8a867a3d101/2b215569-0b53-46c8-b9ff-3b65544ad091_tom-ford.png?v=b5e6d8e2592205b756912780be28dffb" },
  { name: "Tesla", logo: "https://storage.readdy-site.link/project_files/9d47c388-655f-4be5-bf40-a8a867a3d101/d084d414-fa2b-468d-bce8-6c1f438121a0_tesla.png?v=4f997449d5815421ae094acd91ac434b" },
  { name: "PepsiCo", logo: "https://storage.readdy-site.link/project_files/9d47c388-655f-4be5-bf40-a8a867a3d101/58ae5a6f-3627-4806-b961-478f06018a25_pepsico.png?v=23399b7a812a3016d956cf8cd12870b8" },
  { name: "P&G", logo: "https://storage.readdy-site.link/project_files/9d47c388-655f-4be5-bf40-a8a867a3d101/d56c50f9-0a82-4650-bcf2-4b1601be156a_pg.png?v=afc5c3a2dd37a7c9f63be39b679a9ebf" },
];

const grainStyle: React.CSSProperties = {
  backgroundImage:
    "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.4'/%3E%3C/svg%3E\")",
  backgroundSize: "200px 200px",
};

export default function NosotrosSection() {
  const { t } = useTranslation();
  const trackRef = useRef<HTMLDivElement>(null);
  const stats = t("nosotros.stats", { returnObjects: true }) as unknown as { value: string; label: string; desc: string }[];

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    let animationId: number;
    let position = 0;
    const speed = 0.6;

    const animate = () => {
      position -= speed;
      const halfWidth = track.scrollWidth / 2;
      if (Math.abs(position) >= halfWidth) {
        position = 0;
      }
      track.style.transform = `translateX(${position}px)`;
      animationId = requestAnimationFrame(animate);
    };

    animationId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationId);
  }, []);

  const doubled = [...brands, ...brands, ...brands];

  return (
    <section
      id="nosotros"
      className="relative overflow-hidden"
      style={{ backgroundColor: "#0d0b1e" }}
    >
      {/* Grain overlay — cubre toda la sección */}
      <div
        className="absolute inset-0 opacity-[0.15] pointer-events-none z-10"
        style={grainStyle}
      />

      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20slow%20motion%20fashion%20model%20walking%20on%20a%20dark%20moody%20street%20in%20Paris%20at%20night%2C%20dramatic%20side%20lighting%2C%20silk%20fabric%20texture%2C%20deep%20shadows%2C%20luxury%20editorial%20photography%2C%20ultra%20high%20contrast%2C%20dark%20navy%20and%20black%20tones%2C%20film%20grain%2C%20anamorphic%20lens%20flare%2C%20very%20atmospheric%20and%20sophisticated&width=1600&height=900&seq=nosotros-bg-01&orientation=landscape"
          alt="Cinematic background"
          className="w-full h-full object-cover object-center"
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(105deg, #0d0b1e 38%, rgba(13,11,30,0.82) 60%, rgba(13,11,30,0.35) 100%)",
          }}
        />
      </div>

      {/* ── CONTENIDO UNIFICADO ── */}
      <div className="relative z-10 px-6 md:px-16 lg:px-24 pt-24 md:pt-32 pb-16 md:pb-20">
        <div className="max-w-7xl mx-auto w-full">

          {/* Fila principal: copy + stats */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 md:gap-16 items-center mb-14 md:mb-20">

            {/* Left — copy */}
            <div className="lg:col-span-6 xl:col-span-5">
              <p className="text-brand-lime text-xs uppercase tracking-[0.25em] font-medium mb-8">
                {t("nosotros.tag")}
              </p>
              <h2 className="text-4xl md:text-6xl xl:text-7xl font-black text-white leading-[1.05] mb-8 md:mb-10">
                {t("nosotros.title1")}<br />
                <em className="not-italic italic font-thin text-white/40">{t("nosotros.title2")}</em><br />
                {t("nosotros.title3")}
              </h2>
              <div className="w-12 h-px mb-10" style={{ backgroundColor: "#ed0578" }} />
              <p className="text-white/60 text-base md:text-lg leading-relaxed max-w-md">
                {t("nosotros.body")}
              </p>
            </div>

            {/* Right — stats */}
            <div className="lg:col-span-5 xl:col-span-4 lg:col-start-8 xl:col-start-9 flex flex-col">
              {stats.map((stat, i) => (
                <div
                  key={stat.label}
                  className="flex items-start gap-4 sm:gap-6 py-6 sm:py-8"
                  style={{ borderBottom: i < stats.length - 1 ? "1px solid rgba(255,255,255,0.07)" : "none" }}
                >
                  <AnimatedStat
                    value={stat.value}
                    className="text-2xl sm:text-4xl md:text-5xl xl:text-6xl font-black leading-none flex-shrink-0"
                    style={{ color: "#ed0578" }}
                  />
                  <div className="pt-1">
                    <p className="text-white text-xs sm:text-sm font-semibold uppercase tracking-wider sm:tracking-widest mb-1">
                      {stat.label}
                    </p>
                    <p className="text-white/35 text-xs leading-relaxed">{stat.desc}</p>
                  </div>
                </div>
              ))}
            </div>

          </div>

          {/* ── DIVISOR CON LABEL ── */}
          <div className="flex items-center gap-3 sm:gap-6 mb-8 md:mb-10">
            <div className="flex-1 h-px" style={{ backgroundColor: "rgba(255,255,255,0.08)" }} />
            <p className="text-white/40 text-[10px] sm:text-xs uppercase tracking-[0.2em] sm:tracking-[0.3em] whitespace-nowrap flex-shrink-0 text-center">
              {t("nosotros.brandsLabel")}
            </p>
            <div className="flex-1 h-px" style={{ backgroundColor: "rgba(255,255,255,0.08)" }} />
          </div>

          {/* ── MARQUEE ── */}
          <div className="relative overflow-hidden">
            {/* Left fade */}
            <div
              className="absolute left-0 top-0 bottom-0 w-20 z-10 pointer-events-none"
              style={{ background: "linear-gradient(to right, #0d0b1e, transparent)" }}
            />
            {/* Right fade */}
            <div
              className="absolute right-0 top-0 bottom-0 w-20 z-10 pointer-events-none"
              style={{ background: "linear-gradient(to left, #0d0b1e, transparent)" }}
            />

            <div
              ref={trackRef}
              className="flex items-center will-change-transform"
              style={{ width: "max-content" }}
            >
              {doubled.map((brand, i) => (
                <div
                  key={`${brand.name}-${i}`}
                  className="flex items-center justify-center px-6 sm:px-10 py-4 flex-shrink-0 group cursor-default"
                  style={{ borderRight: "1px solid rgba(255,255,255,0.06)" }}
                >
                  <img
                    src={brand.logo}
                    alt={brand.name}
                    className="h-[34px] sm:h-[44px] w-auto max-w-[140px] sm:max-w-[166px] object-contain opacity-40 group-hover:opacity-100 transition-opacity duration-300 brightness-0 invert"
                  />
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
